import {
  SET_PURCHASE_DATA,
  PURCHASE_SESSION_FETCHING_INIT,
  PURCHASE_SUMMARY_PLANS_FETCHING_INIT,
  DATA_FETCH_INIT,
} from "./types";
const initialState = {
  //common variables
  transfer_rate: 0,

  session_list: [],
  total_sessions: 0,
  session_page: 1,
  session_perpage: 20,
  session_search: "",
  session_list_refetch: false,
  session_list_refetch_force: false,
  //create session variables
  create_session_popup: false,
  C_session_name: "",
  C_partner: "",
  C_session_date: new Date(),
  C_report_type: "",
  C_distributor: "",
  C_temp_session: false,
  C_discounted: false,
  C_session_info: null,
  C_session_submission_date: null,
  C_dealer_id: "",
  file_upload_percentage: 0,
  //edit session variables
  edit_session_popup: false,
  Ed_session_name: "",
  Ed_partner: "",
  Ed_session_date: new Date(),
  Ed_report_type: "",
  Ed_distributor: "",
  Ed_temp_session: false,
  Ed_discounted: false,
  Ed_session_details: null,
  Ed_dealer_id: null,
  //delete session variables
  delete_session_popup: false,
  Del_session_details: null,
  del_btn_disable: false,

  // Summary page variables
  isSummaryResultLoading: true, //
  isInvalidSessionLink: false,
  summaryData: {},

  // Results table variables
  purchaseResults_list: [],
  isResultDataLoading: false,
  purchaseResults_Refetch: false,
  purchaseResults_page: 1,
  purchaseResults_perpage: 20,
  purchaseResults_total_count: 0,
  verticalsList: [],
  dealer_id: null,
  business_type: null,

  submit_btn_disable: false,
  isDataLoading: false,

  //Summary data table variables
  purchaseSummary_list: [],
  isPurchaseSummaryLoading: false,
  purchaseSummary_Refetch: false,
  purchaseSummary_page: 1,
  purchaseSummary_perpage: 20,
  purchaseSummary_total_count: 0,

  //check-kit table variables
  purchaseCheckKit_list: [],
  isPurchaseCheckKitLoading: false,
  purchaseCheckKit_Refresh: false,
  purchase_check_kit_refetch: false,
  purchaseCheckKit_page: 1,
  purchaseCheckKit_perpage: 20,
  purchaseCheckKit_total_count: 0,

  purchaseTutorialModal: false,
  vendor_opts: [],
  Creg_plans: [],
  sessionMyplanCheck: true,
  ppePlanIdPurchase: "",
  dealerIdPurchase: "",
  show_confirmation_popup: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_PURCHASE_DATA:
      return { ...state, ...action.payload };
    case PURCHASE_SESSION_FETCHING_INIT: {
      return {
        ...state,
        session_list_refetch: false,
        session_list_refetch_force: false,
        isDataLoading: true,
      };
    }
    case PURCHASE_SUMMARY_PLANS_FETCHING_INIT: {
      return { ...state, summaryPlans_Refetch: false, isDataLoading: true };
    }
    case DATA_FETCH_INIT:
      return { ...state, isDataLoading: true, ...action.payload };
    default:
      return state;
  }
};
